import { render, staticRenderFns } from "./AuthorizationView.vue?vue&type=template&id=080aba1a&"
import script from "./AuthorizationView.vue?vue&type=script&lang=js&"
export * from "./AuthorizationView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationView.vue?vue&type=style&index=0&id=080aba1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports